import { useEffect, useState } from "react";

const useFetchExamDetails = () => {
  const [participantDetails, setParticipantDetails] = useState(null);

  useEffect(() => {
    const participant = JSON.parse(localStorage.getItem("practido-examAuth"));
    if (participant) {
      setParticipantDetails({
        ...participant?.student,
        examSubject: participant?.subject,
      });
    }
  }, []);

  return participantDetails;
};

export default useFetchExamDetails;
